import * as React from 'react'
import Navbar from '../../setup/Navbar'
import { Container, Grid2, IconButton, MenuItem, TextField, Tooltip } from '@mui/material'
import ButtonNormal from '../../../BuiltInComponent/ButtonNormal'
import { useNavigate } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import StickyHeadTable from '../../../BuiltInComponent/TableWithPagination'
import Loading from '../../../BuiltInComponent/Loading'
import { completePO, getPOData, getPOMasterData } from '../../../features/StockManagement/Purchases/poSlice'
import { printPurchaseDocument } from '../../../utils/purchaseDocumentPrint'
import { exportPurchaseDocumentExcel, exportPurchaseDocumentPDF } from '../../../utils/purchaseDocumentExport'
import AssessmentIcon from '@mui/icons-material/Assessment'

export default function PurchaseRequestList() {

    const navigate = useNavigate()
    const dispatch = useDispatch()
    const { masterData, isLoading } = useSelector((state) => state.po)
    const { user } = useSelector((state) => state.auth)
    const [statusFilter, setStatusFilter] = React.useState('Pending')

    const filteredPOs = React.useMemo(() => {
        if (statusFilter === 'All') return masterData || []
        return (masterData || []).filter((row) => row.deliveryStatus === statusFilter)
    }, [masterData, statusFilter])

    React.useEffect(() => {
        dispatch(getPOMasterData())
        // dispatch(getPurchaseDetailData('blank'))
    }, [dispatch])

    const tableColumns = [
        { fieldName: 'poID', cName: 'Invoice No', textAlign: 'left', width: 80, status: 'en', dType: 'string' },
        { fieldName: 'poID', cName: 'P.R. ID', textAlign: 'left', width: 80, status: 'en', dType: 'string' },
        { fieldName: 'entDate', cName: 'Post Date', textAlign: 'left', width: 80, status: 'en', dType: 'date' },
        { fieldName: 'dispName', cName: 'Request By', textAlign: 'left', width: 80, status: 'en', dType: 'string' },
        { fieldName: 'PartyName', cName: 'Department', textAlign: 'left', width: 80, status: 'en', dType: 'string' },
        { fieldName: 'remarks', cName: 'Remarks', textAlign: 'left', width: 80, status: 'en', dType: 'string' },
        { fieldName: 'deliveryStatus', cName: 'Current Status', textAlign: 'left', width: 120, status: 'en', dType: 'string' },
        { fieldName: 'totalItems', cName: 'Total Items', textAlign: 'right', width: 80, status: 'en', dType: 'number' },
        { fieldName: 'Edit', cName: 'Edit', textAlign: 'center', width: 80, status: 'en', dType: 'string', action: true },
        { fieldName: 'Delete', cName: 'Delete', textAlign: 'center', width: 80, status: 'dis', dType: 'string', action: true },
        { fieldName: 'Print', cName: 'Print', textAlign: 'center', width: 80, status: 'en', dType: 'string', icon: 'print', action: true },
        { fieldName: 'Excel', cName: 'Excel', textAlign: 'center', width: 80, status: 'en', icon: 'excel', action: true },
        { fieldName: 'PDF', cName: 'PDF', textAlign: 'center', width: 70, status: 'en', icon: 'pdf', action: true },
        { fieldName: 'Complete', cName: 'Complete', textAlign: 'center', width: 110, status: 'en', dType: 'string', buttonText: 'Complete', hideWhenField: 'deliveryStatus', hideWhenValue: 'Completed', action: true },
    ];

    const onEditClick = async (itemCode) => {
        navigate('/AddPurchaseOrder', { state: { poID: itemCode } })
    }
    const onDeleteClick = async (itemCode) => { }

    const onCompleteClick = async (poID) => {
        if (!window.confirm(`PO #${poID} ko complete karna hai? Is ke baad ye GRN selection mein available nahi hoga.`)) return
        try {
            await dispatch(completePO(poID)).unwrap()
            await dispatch(getPOMasterData())
        } catch (error) {
            alert(`PO complete nahi ho saka: ${error}`)
        }
    }

    const onPrintClick = async (poID) => {
        const printWindow = window.open('', '_blank', 'width=1000,height=800')
        if (!printWindow) return alert('Please allow pop-ups to print the purchase order.')
        printWindow.document.write('<p style="font-family:Arial;padding:24px">Preparing purchase order...</p>')
        try {
            const data = await dispatch(getPOData(poID)).unwrap()
            const listRow = (masterData || []).find(row => Number(row.poID) === Number(poID))
            printPurchaseDocument(printWindow, 'PO', data?.pm?.[0], data?.pd || [], listRow, user)
        } catch (error) {
            printWindow.close()
            alert(`Purchase Order print failed: ${error}`)
        }
    }

    const exportDocument = async (poID, exporter) => {
        try {
            const data = await dispatch(getPOData(poID)).unwrap()
            const listRow = (masterData || []).find(row => Number(row.poID) === Number(poID))
            exporter({ type: 'PO', master: data?.pm?.[0], details: data?.pd || [], listRow })
        } catch (error) {
            alert(`Purchase Order export failed: ${error}`)
        }
    }
    const onAddNewClick = () => {

        navigate('/AddPurchaseOrder')

    }

    return (
        <>
            <Navbar />
            <Container>
                <Grid2 container spacing={2} sx={{ marginTop: 2, marginBottom: 2 }}>
                    <Grid2 size={{ xs: 12, md: 5 }}></Grid2>
                    <Grid2 size={{ xs: 12, sm: 6, md: 3 }}>
                        <TextField
                            select
                            fullWidth
                            size='small'
                            label='Status Filter'
                            value={statusFilter}
                            onChange={(event) => setStatusFilter(event.target.value)}
                        >
                            <MenuItem value='All'>All</MenuItem>
                            <MenuItem value='Pending'>Pending</MenuItem>
                            <MenuItem value='Partial Delivered'>Partial Delivered</MenuItem>
                            <MenuItem value='Completed'>Completed</MenuItem>
                        </TextField>
                    </Grid2>
                    <Grid2 size={{ xs: 12, sm: 4, md: 3 }}>
                        <ButtonNormal text='Add New Purchase order' onClick={onAddNewClick} />
                    </Grid2>
                    <Grid2 size={{ xs: 12, sm: 2, md: 1 }} sx={{ textAlign: 'right' }}>
                        <Tooltip title='Current Stock Report'>
                            <IconButton color='primary' size='large' sx={{ p: 1.25 }} onClick={() => navigate('/CurrentStock')}>
                                <AssessmentIcon fontSize='large' />
                            </IconButton>
                        </Tooltip>
                    </Grid2>
                </Grid2>
                {isLoading ? <Loading /> :
                    <StickyHeadTable tableColumns={tableColumns} tableData={filteredPOs}
                        onEditClick={onEditClick} onDeleteClick={onDeleteClick} onButtonClick={onCompleteClick} onPrintClick={onPrintClick}
                        onExcelClick={(poID) => exportDocument(poID, exportPurchaseDocumentExcel)} onPdfClick={(poID) => exportDocument(poID, exportPurchaseDocumentPDF)} />
                }

            </Container>
        </>
    )
}
